import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import i18n from '../i18n';

Vue.use(VueRouter);

const routes = [{
        path: '/',
        redirect: `/${i18n.locale}`
    },
    {
        path: '/:lang',
        component: {
            render(c) { return c('router-view') }
        },
        children: [{
                path: "/",
                name: "Home",
                meta: { url: "" },
                component: Home,
            },
            {
                path: "year-in-review",
                name: "YarInReview",
                meta: { parent: "strategicreview", url: "year-in-review", title: " A Year In Review", title_ar: "أهم محطات مجموعة زين في العام " },
                component: () =>
                    import ("../views/yearInReview.vue")
            },
            {
                path: "2020-at-glance",
                name: "glance",
                meta: { parent: "strategicreview", url: "2020-at-glance", title: " 2020 At A Glance", title_ar: "لمحة سريعة عن زين في العام 2020" },
                component: () =>
                    import ("../views/" + i18n.locale + "/2020-at-glance.vue")
            },
            {
                path: "strategy",
                name: "strategy",
                meta: { parent: "strategicreview", url: "strategy", title: "Strategy", title_ar: "استراتيجيتنا" },
                component: () =>
                    import ("../views/strategy.vue")
            },
            {
                path: "technology",
                name: "technology",
                meta: { parent: "strategicreview", url: "technology", title: "technology", title_ar: "التكنولوجيا" },
                component: () =>
                    import ("../views/Technology.vue")
            },
            {
                path: "zain-drone",
                name: "zain-drone",
                meta: { parent: "strategicreview", url: "zain-drone", title: "Zain Drone", title_ar: "زين درون" },
                component: () =>
                    import ("../views/zainDrone.vue")
            },
            {
                path: "regulatory",
                name: "regulatory",
                meta: { parent: "strategicreview", url: "regulatory", title: "regulatory", title_ar: "العلاقات التنظيمية" },
                component: () =>
                    import ("../views/regulatory.vue")
            },
            {
                path: "commercial-customer",
                name: "commercial-customer",
                meta: { parent: "strategicreview", url: "commercial-customer", title: "COMMERCIAL AND CUSTOMER EXPERIENCE", title_ar: "العمليات التجارية" },
                component: () =>
                    import ("../views/" + i18n.locale + "/commercial-customer.vue")
            },
            {
                path: "diversity-inclusion",
                name: "diversity-inclusion",
                meta: { parent: "strategicreview", url: "diversity-inclusion", title: "DIVERSITY & INCLUSION", title_ar: "التنوّع والاشتمال" },
                component: () =>
                    import ("../views/Diversity-inclusion.vue")
            },
            {
                path: "keymilestone",
                name: "keymilestone",
                meta: { parent: "strategicreview", url: "keymilestone", title: "Key Milestones", title_ar: "معالم رئيسية" },
                component: () =>
                    import ("../views/" + i18n.locale + "/keymilestone.vue")
            },
            {
                path: "risk-management",
                name: "risk-management",
                meta: { parent: "strategicreview", url: "risk-management", title: "risk management", title_ar: "إدارة المخاطر" },
                component: () =>
                    import ("../views/risk-manegement.vue")
            },
            {
                path: "world-of-zain",
                name: "worldofzain",
                meta: { parent: "strategicreview", url: "world-of-zain", title: "THE WORLD OF ZAIN", title_ar: "التواجد الجغرافي لمجموعة زين" },
                component: () =>
                    import ("../views/worldofzain.vue")
            },
            {
                path: "world-of-zain/middleeast",
                name: "worldofzain-middleeast",
                meta: { parent: "strategicreview", url: "world-of-zain/middleeast", title: "THE WORLD OF ZAIN", title_ar: "التواجد الجغرافي لمجموعة زين" },
                component: () =>
                    import ("../views/worldofzain-middleeast.vue")
            },
            {
                path: "world-of-zain/africa",
                name: "worldofzain-africa",
                meta: { parent: "strategicreview", url: "world-of-zain/africa", title: "THE WORLD OF ZAIN", title_ar: "التواجد الجغرافي لمجموعة زين" },
                component: () =>
                    import ("../views/worldofzain-africa.vue")
            },
            {
                path: "vice-chairman",
                name: "vice-chairman",
                meta: { parent: "strategicreview", url: "vice-chairman", title: "VICE-CHAIRMAN AND GROUP CEO STATEMENT", title_ar: "كلمة نائب رئيس مجلس الإدارة والرئيس التنفيذي " },
                component: () =>
                    import ("../views/vice-chairman.vue")
            },
            {
                path: "KPIs",
                name: "kpi",
                meta: { parent: "strategicreview", url: "KPIs", title: "GROUP KEY PERFORMANCE INDICATORS", title_ar: "أهم مؤشرات الأداء " },
                component: () =>
                    import ("../views/" + i18n.locale + "/kpis.vue")
            },
            {
                path: "BOD-message",
                name: "BOD-message",
                meta: { parent: "strategicreview", url: "BOD-message", title: "Board of Directors Message", title_ar: "تقرير مجلس الإدارة " },
                component: () =>
                    import ("../views/BODMessage.vue")
            },
            {
                path: "business-operations",
                name: "business-operations",
                meta: { parent: "strategicreview", url: "business-operations", title: "business operations", title_ar: "شركات المجموعة" },
                component: () =>
                    import ("../views/businessOperations.vue")
            },
            {
                path: "table-of-contents",
                name: "tablecontents",
                meta: { url: "table-of-contents" },
                component: () =>
                    import ("../views/" + i18n.locale + "/tableOfContents.vue")
            },
            {
                path: "governance/rules",
                name: "rules",
                meta: { parent: "governance", url: "governance/rules", title: "rules", title_ar: "قواعد" },
                component: () =>
                    import ("../views/governance/" + i18n.locale + "/rules.vue")
            },
            {
                path: "governance/executive-management",
                name: "executive-management",
                meta: { parent: "governance", url: "governance/executive-management", title: "executive management", title_ar: "الإدارة التنفيذية" },
                component: () =>
                    import ("../views/governance/executiveManagement.vue")
            },
            {
                path: "governance/introduction",
                name: "governance",
                meta: { parent: "governance", url: "governance/introduction", title: "governance", title_ar: "الحوكمة" },
                component: () =>
                    import ("../views/governance/introduction.vue")
            },
            {
                path: "governance/board-of-directors",
                name: "board-of-directors",
                meta: { parent: "governance", url: "governance/board-of-directors", title: "board of directors", title_ar: "مجلس الإدارة " },
                component: () =>
                    import ("../views/governance/boardDirectors.vue")
            },
            {
                path: "fanacial-statement-table",
                name: "fanacial-statement-table",
                meta: { parent: "governance", url: "fanacial-statement-table" },
                component: () =>
                    import ("../views/" + i18n.locale + "/fanacial-statement-table.vue")
            },
            {
                path: "governance/board-committee",
                name: "board-committee",
                meta: { parent: "governance", url: "governance/board-committee", title: "board committees", title_ar: "لجان مجلس الإدارة" },
                component: () =>
                    import ("../views/governance/boardCommitte.vue")
            },
            {
                path: "governance/remuneration-report",
                name: "Remuneration-Report",
                meta: { parent: "governance", url: "governance/remuneration-report", title: "Remuneration Report", title_ar: "تقرير المكافآت" },
                component: () =>
                    import ("../views/governance/remunerationReport.vue")
            },
            {
                path: "corporate-sustainability",
                name: "corporate-sustainability",
                meta: { parent: "strategicreview", url: "corporate-sustainability", title: "corporate sustainability", title_ar: "الاستدامة" },
                component: () =>
                    import ("../views/corporate-sustainability.vue")
            },
            {
                path: "financial-statements/financial-position",
                name: "financial-position",
                meta: { parent: "financial", url: "financial-statements/financial-position", title: "CONSOLIDATED STATEMENT OF FINANCIAL POSITION", title_ar: "بيان المركز المالي المجمع " },
                component: () =>
                    import ("../views/financial-statements/" + i18n.locale + "/financialPosition.vue")
            },
            {
                path: "financial-statements/profit-loss",
                name: "profit-loss",
                meta: { parent: "financial", url: "financial-statements/profit-loss", title: "CONSOLIDATED STATEMENT OF PROFIT OR LOSS", title_ar: "يان الربح أو الخسارة المجمبيان الربح  أو الخسارة المجمع السنة المنتهية في " },
                component: () =>
                    import ("../views/financial-statements/" + i18n.locale + "/profitLoss.vue")
            },
            {
                path: "financial-statements/comprehensive-income",
                name: "comprehensive-income",
                meta: { parent: "financial", url: "financial-statements/comprehensive-income", title: "Profit or Loss and Other Comprehensive Income", title_ar: "بيان الربح أو الخسارة والدخل الشامل الآخر المجمع " },
                component: () =>
                    import ("../views/financial-statements/" + i18n.locale + "/comprehensiveIncome.vue")
            },
            {
                path: "financial-statements/changes-in-equity",
                name: "changes-equity",
                meta: { parent: "financial", url: "financial-statements/changes-in-equity", title: "Consolidated Statement of Changes in Shareholders’ Equity", title_ar: "بيان التغيرات في حقوق المساهمين المجمع السنة المنتهية في" },
                component: () =>
                    import ("../views/financial-statements/" + i18n.locale + "/changesInEquity")
            },
            {
                path: "financial-statements/cash-flows",
                name: "cash-flows",
                meta: { parent: "financial", url: "financial-statements/cash-flows", title: "CONSOLIDATED STATEMENT OF CASH FLOWS", title_ar: "بيان التدفقات النقدية المجمع السنة المنتهية" },
                component: () =>
                    import ("../views/financial-statements/" + i18n.locale + "/cashFlows")
            },
            {
                path: "financial-statements/notes-To-The-Consolidated-Financial-Statements",
                name: "Financial-Statements",
                meta: { parent: "financial", url: "financial-statements/notes-To-The-Consolidated-Financial-Statements", title: "NOTES TO THE CONSOLIDATED FINANCIAL STATEMENTS ", title_ar: "إيضاحات حول البيانات المالية المجمعة" },
                component: () =>
                    import ("../views/financial-statements/notesToTheConsolidatedFinancialStatements.vue")
            },
            {
                path: "financial-statements/independent-auditors-report",
                name: "auditors-report",
                meta: { parent: "financial", url: "financial-statements/independent-auditors-report", title: "Independent Auditor’s Report", title_ar: "تقرير مراقب الحسابات المستقل" },
                component: () =>
                    import ("../views/financial-statements/" + i18n.locale + "/independentAuditorsReport")
            }
        ]
    },

];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    // scrollBehavior(to, from, savedPosition) {
    //     return new Promise((resolve, reject) => {
    //         setTimeout(() => {
    //             resolve({ x: 0, y: 0 });
    //         }, 500);
    //     });
    // }
});

export default router;